import { render, staticRenderFns } from "./RegisterDetailDialog.vue?vue&type=template&id=4a22abea&scoped=true"
import script from "./RegisterDetailDialog.vue?vue&type=script&lang=js"
export * from "./RegisterDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./RegisterDetailDialog.vue?vue&type=style&index=0&id=4a22abea&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a22abea",
  null
  
)

export default component.exports